import gsap from 'gsap';
( function( app ) {
  const COMPONENT = {
    init: function() {
      const mm = gsap.matchMedia();
      mm.add( '(min-width: 1024px)', () => {
        $( '.click-to-play' ).each( function( key, val ) {
          const mediaLayer = $( this ).find( '.click-to-play__media-layer' )[0];
          const media = $( this ).find( '.click-to-play__media' )[0];
          const content = $( this ).find( '.click-to-play__content' )[0];
          const overlay = $( this ).find( '.bg-theme-overlays-dark' )[0];
          const height = $( this ).outerHeight();
          let topOffset = $( '.navbar' ).outerHeight();

          if ( $( '#wpadminbar' ).length ) {
            topOffset += $( '#wpadminbar' ).outerHeight();
          }

          if ( window.hasMotion ) {
            const pinner = gsap.timeline( {
              scrollTrigger: {
                pin: val,
                trigger: this,
                start: 'top ' + topOffset,
                end: 'bottom top',
                scrub: 0,
                // markers: true,
              },
            } );

            const tl = gsap.timeline( {
              scrollTrigger: {
                trigger: this,
                start: 'top 50%',
                end: 'bottom 50%',
                scrub: 1,
              },
            } );

            tl.to( content, {translateY: '-100%', opacity: 0, ease: 'linear', delay: 1, duration: 0.5}, 0 );
            tl.to( overlay, {opacity: 0, ease: 'linear', delay: 1, duration: 0.5}, 0 );
            tl.to( media, {clipPath: 'inset(0px round 0px)', ease: 'linear', delay: 1, duration: 0.5}, 0 );
          }

          // Link Cursor
          const zone = $( val ).find( '.cursor-zone' )[0];
          const cursor = $( val ).find( '.custom-cursor' )[0];
          const innerCursor = $( val ).find( '.custom-cursor__inner' )[0];

          if ( !cursor ) {
            return;
          }

          let x = 0;
          let y = 0;
          let active = false;
          let escaped = false;

          zone.addEventListener( 'mouseenter', () => {
            active = true;
            cursor.style.opacity = 1;
            innerCursor.style.transform = `scale(1)`;
          } );

          zone.addEventListener( 'mouseleave', () => {
            active = false;
            escaped = false;
            zone.style.cursor = 'auto';
            innerCursor.style.transform = `scale(0)`;

            setTimeout( function() {
              cursor.style.opacity = 0;
            }, 200 );
          } );

          // Track mouse ONLY relative to the zone
          zone.addEventListener( 'mousemove', ( e ) => {
            const rect = zone.getBoundingClientRect();

            x = e.clientX - ( rect.left / 2 );
            y = e.clientY - rect.top;

            // Escape hatch check
            const escapeTarget = e.target.closest( '.native-cursor, .loop-video-toggle-state' );

            if ( escapeTarget ) {
              escaped = true;
              zone.style.cursor = 'auto';
              cursor.style.opacity = 0;
            } else {
              escaped = false;
              cursor.style.opacity = 1;
              if ( window.hasMotion ) {
                zone.style.cursor = 'none';
              }
            }

            if ( active && !escaped ) {
              const maxRotation = 25;
              const vw = window.innerWidth;
              const rotateAmount = -maxRotation + ( x / vw ) * ( maxRotation * 2 );

              cursor.style.transform =
            `translate(${x}px, ${y}px) translate(-50%, -50%) rotate( ${rotateAmount}deg )`;
            }
          } );
        } );
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'click-to-play', COMPONENT );
} )( app );
